<template>
    <div class="snapshot-item">
        <img :src="$image(snapshot.image)" :alt="snapshot.title" width="40px" height="40px">
        <div class="d-flex flex-column">
            <span v-if="snapshot.value" class="snapshot-item-value">
                {{ snapshot.value }}<span class="snapshot-item-value-unit">%</span>
            </span>
            <span class="font f-w-700 f-s-small-16 f-s-18 l-h-28 l-h-small-24 ">{{ snapshot.title }}</span>
            <p class="font m-0 f-w-400 l-h-20">
                {{ snapshot.sub_title }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        snapshot: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
.snapshot-item {
    display: flex;
    flex-flow: column;
    gap: 16px;
    align-items: flex-start;
    justify-content: flex-start;

    &-value {
        color: var(--Content-Accent-2ndAccent, var(--Content-Accent-2ndAccent, #009B8E));
        text-align: left;
        font-size: 32px;
        font-style: normal;
        font-weight: 800;
        line-height: 40px; /* 125% */
        letter-spacing: -1px;

        &-unit {
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px; /* 155.556% */
        }
    }

    @media (max-width: 768px) {
        &-value {
            font-size: 24px;
            line-height: 32px;
            letter-spacing: -0.75px;

            &-unit {
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }

    @media only screen and (min-width: 992px) {
        flex-flow: inherit;
        max-width: 312px;
        width: 100%;
        align-items: center !important;
    }
}
</style>
